import React from 'react';
import './style.css';
import {
  getFormattedQoEPrice,
  getFormattedQoELitePrice,
  shouldShowStartingAtQoEPrice,
  shouldShowStartingAtQoELitePrice,
} from '../utils/pricingCalculations';

const ComissionQuote = ({ price, dueDiligenceTimeline }) => {
  const qoePrice = getFormattedQoEPrice(price, dueDiligenceTimeline);
  const qoeLitePrice = getFormattedQoELitePrice(price, dueDiligenceTimeline);
  const shouldShowStartingAtQoE = shouldShowStartingAtQoEPrice(price);
  const shouldShowStartingAtQoELite = shouldShowStartingAtQoELitePrice(price);

  const renderPrice = (priceValue, showStartingAt = false) => (
    <div className='card-price-wrapper'>
      {showStartingAt && <span className='price-prefix'>Starting at</span>}
      <span>{priceValue}</span>
    </div>
  );

  return (
    <div className='quote-results-grid-container'>
      <div className='quote-results-grid'>
        {/* Quality of Earnings (QoE) */}
        <div className='quote-result-card featured'>
          <div className='popular-banner'>MOST POPULAR</div>
          <div className='card-content-wrapper'>
            <h4>Quality of Earnings (QoE)</h4>
          </div>
          {renderPrice(qoePrice, shouldShowStartingAtQoE)}
        </div>

        {/* Quality of Earnings "Lite" */}
        <div className='quote-result-card'>
          <div className='card-content-wrapper'>
            <h4>Quality of Earnings "Lite"</h4>
          </div>
          {renderPrice(qoeLitePrice, shouldShowStartingAtQoELite)}
        </div>

        {/* Preliminary Vetting */}
        <div className='quote-result-card'>
          <div className='card-content-wrapper'>
            <h4>Preliminary Vetting Report</h4>
          </div>
          {renderPrice('$750')}
        </div>
      </div>
    </div>
  );
};

export default ComissionQuote;
